import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Audience`}</h1>
    <p>{`Use attributes to target an specific audience.`}</p>
    <h2>{`Hook`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { useExperiment } from 'react-tesfy';

const Hook = () => {
  const id = 'experiment-2';
  const variationId1 = useExperiment({ id, attributes: { countryCode: 've' } }); // null
  const variationId2 = useExperiment({ id, attributes: { countryCode: 'us' } }); // '0'
};
`}</code></pre>
    <h2>{`Component`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { Experiment, Variation } from 'react-tesfy';

const Simple = () => (
  <>
    <Experiment id="experiment-2" attributes={{ countryCode: 've' }}>
      <Variation>
        Rendered
      </Variation>
      <Variation id="0">
        Not rendered
      </Variation>
    </Experiment>

    <Experiment id="experiment-2" attributes={{ countryCode: 'us' }}>
      <Variation>
        Not endered
      </Variation>
      <Variation id="0">
        Rendered
      </Variation>
    </Experiment>
  </>
);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      